import _export from '../internals/export.js';
import ownKeys$1 from '../internals/own-keys.js';

var $ = _export;
var ownKeys = ownKeys$1; // `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys

$({
  target: 'Reflect',
  stat: true
}, {
  ownKeys: ownKeys
});
